"use client";

import Input from "@/components/frontend/ui/form/inputs/input";
import type { FilterValue } from "@/lib/types/marketsuite/datatypes/filters";
import type { AnyFieldApi } from "@tanstack/react-form-nextjs";
import { useDebouncedCallback } from "@tanstack/react-pacer";

interface MsTextFilterProps {
	blockType: "partner-name";
	field: AnyFieldApi;
	content?: {
		label?: string;
		placeholder?: string;
		description?: string;
	};
	onValueChange?: (value: FilterValue, blockType: "partner-name") => void;
}

export function MsTextFilter({ blockType, field, content, onValueChange }: MsTextFilterProps) {
	const value = Array.isArray(field.state.value) && typeof field.state.value[0] === "string" ? field.state.value[0] : "";
	const debouncedValueChange = useDebouncedCallback((nextValue: string[]) => onValueChange?.(nextValue, blockType), { wait: 400 });

	return (
		<Input
			id={field.name}
			name={field.name}
			type="search"
			value={value}
			label={content?.label}
			placeholder={content?.placeholder ?? undefined}
			description={content?.description}
			onBlur={field.handleBlur}
			onChange={(event) => {
				const nextValue = event.target.value;
				field.handleChange(nextValue ? [nextValue] : []);
				debouncedValueChange(nextValue ? [nextValue] : []);
			}}
		/>
	);
}
